export default __webpack_public_path__ + "static/media/wifi.8a723abf.png";